import React, { Fragment } from 'react';
import { FileEdit, FileText, LogIn, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function SearchUser() {
  const navigate = useNavigate();
  const users = [{
    id: 1,
    username: 'rloeding1',
    fullName: 'Ryan Loeding',
    email: 'ryan@rykerrealstate.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 5:21:46 pm'
  }, {
    id: 2,
    username: 'vbam',
    fullName: 'Veronica Barragan',
    email: 'veronicabiam@gmail.com',
    courses: 1,
    notes: false,
    lastLogin: '02/11/2026 5:31:31 pm'
  }, {
    id: 3,
    username: 'jimhunt',
    fullName: 'Jim Hunt',
    email: 'jim@huntazhomes.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 5:03:22 pm'
  }, {
    id: 4,
    username: 'tedy29',
    fullName: 'Ted Araya',
    email: 'thedros.araya@exprealty.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 4:54:22 pm'
  }, {
    id: 5,
    username: 'tim@allhome.com',
    fullName: 'Timothy Rehrmann',
    email: 'timrehr123@gmail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 4:47:19 pm'
  }, {
    id: 6,
    username: 'chuckkayehomes@gmail.com',
    fullName: 'Chuck Kaye',
    email: 'chuckkayehomes@gmail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 4:37:25 pm'
  }, {
    id: 7,
    username: 'williamkline110@gmail.com',
    fullName: 'William Kline',
    email: 'williamkline110@gmail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 4:37:08 pm'
  }, {
    id: 8,
    username: 'skobr@hotmail.com',
    fullName: 'Shauna Gliss',
    email: 'skobr@hotmail.com',
    courses: 4,
    notes: false,
    lastLogin: '02/11/2026 4:23:50 pm'
  }, {
    id: 9,
    username: 'paulboyle',
    fullName: 'Paul Boyle',
    email: 'paul.boyle@cushwake.com',
    courses: '',
    notes: true,
    lastLogin: '02/11/2026 4:23:09 pm'
  }, {
    id: 10,
    username: 'z.gunnell',
    fullName: 'Zachary Gunnell',
    email: 'gunnell.zachary@gmail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 4:05:19 pm'
  }, {
    id: 11,
    username: 'Ghostlights',
    fullName: 'Nicolas Kraus',
    email: 'nico.mrkaus@gmail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 4:01:28 pm'
  }, {
    id: 12,
    username: 'lmacgregor',
    fullName: 'Lorraine MacGregor',
    email: 'lmacgregor55@gmail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 3:54:48 pm'
  }, {
    id: 13,
    username: 'tmrossman',
    fullName: 'TAMMY Rossman',
    email: 'tammylasouragent@yahoo.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 3:51:22 pm'
  }, {
    id: 14,
    username: 'arizonalifestyle@aol.com',
    fullName: 'Brent Ballard',
    email: 'arizonalifestyle@aol.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 3:46:32 pm'
  }, {
    id: 15,
    username: 'jrompeter',
    fullName: 'Jill Trompeter',
    email: 'jill2013@gmail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 3:08:56 pm'
  }, {
    id: 16,
    username: 'pgeretti',
    fullName: 'Phillip Geretti',
    email: 'pgeretti@cox.net',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 2:52:56 pm'
  }, {
    id: 17,
    username: 'Justin87402',
    fullName: 'Justin DiBlase',
    email: 'jdiblase@e-retail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 2:46:52 pm'
  }, {
    id: 18,
    username: 'jakethomas@westusa.com',
    fullName: 'Jacob Thomas',
    email: 'jakethomas@westusa.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 2:31:58 pm'
  }, {
    id: 19,
    username: 'Plenstrohin',
    fullName: 'Peter Lenstrohin',
    email: 'Plenstrohin@aol.com',
    courses: 0,
    notes: false,
    lastLogin: '02/11/2026 2:21:08 pm'
  }, {
    id: 20,
    username: 'bsgranpa',
    fullName: 'William Scott',
    email: 'billscott16@gmail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 1:36:17 pm'
  }, {
    id: 21,
    username: 'igetyouhome',
    fullName: 'Paul Bratcher',
    email: 'igetyouhome@gmail.com',
    courses: 0,
    notes: false,
    lastLogin: '02/11/2026 1:52:10 pm'
  }, {
    id: 22,
    username: 'Rebeccagodwin11',
    fullName: 'Rebecca Godwin',
    email: 'rebeccag311@gmail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 1:48:20 pm'
  }, {
    id: 23,
    username: 'jan988968',
    fullName: 'Josue Manriquez',
    email: 'jmanriquez1177@gmail.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 1:41:21 pm'
  }, {
    id: 24,
    username: 'ksoule',
    fullName: 'Kimberlea Soule',
    email: 'kim.soule@colliers.com',
    courses: 0,
    notes: false,
    lastLogin: '02/11/2026 1:40:27 pm'
  }, {
    id: 25,
    username: 'nmatthews',
    fullName: 'Natalie Matthews',
    email: 'matthews.natalie@icloud.com',
    courses: '',
    notes: false,
    lastLogin: '02/11/2026 1:21:09 pm'
  }, {
    id: 26,
    username: 'marycolwell',
    fullName: 'mary colwell',
    email: 'MLCHOMES@HOTMAIL.COM',
    courses: 5,
    notes: false,
    lastLogin: '02/11/2026 12:42:15 pm'
  }, {
    id: 27,
    username: 'susanweitzman@mac.com',
    fullName: 'Susan Weitzman',
    email: 'susanweitzman@mac.com',
    courses: 2,
    notes: true,
    lastLogin: '02/11/2026 8:52:35 am'
  }];
  return <div className="space-y-4" data-id="element-1477">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1478">Search User</h1>

      {/* Search bar */}
      <div className="flex items-end gap-2 flex-wrap justify-between" data-id="element-1479">
        <div className="flex items-end gap-2 flex-wrap" data-id="element-1480">
          <div data-id="element-1481">
            <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1482">
              Search
            </label>
            <input type="text" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-40" data-id="element-1483" />
          </div>
          <div data-id="element-1484">
            <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1485">
              Search By
            </label>
            <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-28" data-id="element-1486">
              <option data-id="element-1487">All</option>
              <option data-id="element-1488">Name</option>
              <option data-id="element-1489">Email</option>
              <option data-id="element-1490">Username</option>
              <option data-id="element-1491">Company</option>
            </select>
          </div>
          <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1492">
            Search
          </Button>
        </div>
        <div className="flex items-center gap-2" data-id="element-1493">
          <label className="text-xs text-slate-600" data-id="element-1494">Per page:</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-20" data-id="element-1495">
            <option data-id="element-1496">250</option>
            <option data-id="element-1497">100</option>
            <option data-id="element-1498">50</option>
            <option data-id="element-1499">25</option>
          </select>
        </div>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1500">
        <div className="overflow-x-auto" data-id="element-1501">
          <table className="w-full text-sm text-left" data-id="element-1502">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1503">
              <tr data-id="element-1504">
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1505">
                  User Name
                </th>
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1506">
                  Full Name
                </th>
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1507">Email</th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-1508">
                  Available Courses
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-16" data-id="element-1509">
                  Notes
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-40" data-id="element-1510">
                  Last Login
                </th>
                <th className="px-3 py-3 text-center w-48" data-id="element-1511">
                  <div data-id="element-1512">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1513">
                    Edit | Notes | Login as User | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1514">
              {users.map(user => <tr key={user.id} className="hover:bg-slate-50" data-id="element-1515">
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1516">
                    {user.username}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1517">
                    {user.fullName}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1518">
                    {user.email}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1519">
                    {user.courses !== '' ? user.courses : ''}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1520">
                    {user.notes && <FileEdit className="h-4 w-4 text-blue-500 inline" data-id="element-1521" />}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-slate-600" data-id="element-1522">
                    {user.lastLogin}
                  </td>
                  <td className="px-3 py-2 text-center" data-id="element-1523">
                    <div className="flex items-center justify-center gap-1" data-id="element-1524">
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/users/edit/${user.id}`)} data-id="element-1525">
                        <FileEdit className="h-4 w-4" data-id="element-1526" />
                      </button>
                      <button title="Notes" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate('/users/notes/add')} data-id="element-1527">
                        <FileText className="h-4 w-4" data-id="element-1528" />
                      </button>
                      <button title="Login as User" className="p-1 text-slate-500 hover:text-green-600" data-id="element-1529">
                        <LogIn className="h-4 w-4" data-id="element-1530" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1531">
                        <Trash2 className="h-4 w-4" data-id="element-1532" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1 mt-2" data-id="element-1533">
        <button className="hover:underline" data-id="element-1534">&lt;&lt; previous</button>
        <span className="text-slate-400" data-id="element-1535">|</span>
        <span className="text-slate-900 font-medium" data-id="element-1536">1</span>
        <span className="text-slate-400" data-id="element-1537">|</span>
        <button className="hover:underline" data-id="element-1538">2</button>
        <span className="text-slate-400" data-id="element-1539">|</span>
        <button className="hover:underline" data-id="element-1540">3</button>
        <span className="text-slate-400" data-id="element-1541">|</span>
        <button className="hover:underline" data-id="element-1542">next &gt;&gt;</button>
      </div>
    </div>;
}